function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

/* eslint semi: ["error", "never"]*/

/* eslint arrow-parens: ["error", "as-needed"]*/

/* eslint key-spacing: ["error", { "afterColon": true, "align": "value" }] */

/* eslint no-multi-spaces: ["error", { exceptions: { "ImportDeclaration": true,
                                       "VariableDeclarator": true  } }] */
var CircleInfo = function CircleInfo(props) {
  return React.createElement("svg", props, React.createElement("style", null, "svg", "{", "fill:#b2b6bd", "}"), React.createElement("path", {
    d: "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm-40-176h24v-64h-24c-13.3 0-24-10.7-24-24s10.7-24 24-24h48c13.3 0 24 10.7 24 24v88h8c13.3 0 24 10.7 24 24s-10.7 24-24 24h-80c-13.3 0-24-10.7-24-24s10.7-24 24-24zm40-208a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
  }));
};

CircleInfo.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  height: "1em",
  viewBox: "0 0 512 512"
};
import React from 'react';
import ReactTooltip from 'react-tooltip';
import Spinner from '@engine/components/presentational/base/spinner';

var UploadFile = /*#__PURE__*/function (_React$Component) {
  _inherits(UploadFile, _React$Component);

  var _super = _createSuper(UploadFile);

  function UploadFile(props) {
    var _this;

    _classCallCheck(this, UploadFile);

    _this = _super.call(this, props);

    _this.handleChange = function (event) {
      if (event.target.files && event.target.files[0]) {
        var bytes = 1024;
        var mBytes = 20;

        if (event.target.files[0].size <= mBytes * bytes * bytes) {
          var inputFile = event.target.files[0];
          var reader = new FileReader();

          _this.setState({
            isUploading: true
          });

          reader.onloadend = function () {
            _this.props.onFileUpload(reader, inputFile);

            _this.setState({
              isUploading: false
            });
          };

          reader.readAsDataURL(inputFile);
        }
      }
    };

    _this.state = {
      isUploading: false
    };
    return _this;
  }

  _createClass(UploadFile, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          availableFileFormats = _this$props.availableFileFormats,
          id = _this$props.id,
          tooltip = _this$props.tooltip;
      return React.createElement("div", {
        className: "info-wrapper"
      }, this.state.isUploading && React.createElement(Spinner, {
        color: "refined-green",
        position: "in-btn",
        size: "tiny"
      }), this.props.tooltip && React.createElement(React.Fragment, null, React.createElement(ReactTooltip, {
        id: "".concat(id, "-info-tooltip}"),
        className: "tooltip"
      }, tooltip), React.createElement(CircleInfo, {
        className: "info-icon",
        "data-for": "".concat(id, "-info-tooltip}"),
        "data-tip": true
      })), React.createElement("label", {
        htmlFor: id,
        className: "custom-file-upload"
      }, I18n.t('javascript.v2.wpf_custom_theme.styling.background_image_upload')), React.createElement("input", {
        accept: availableFileFormats,
        className: "background-image",
        disabled: this.state.isUploading,
        id: id,
        onChange: function onChange(event) {
          return _this2.handleChange(event);
        },
        type: "file"
      }));
    }
  }]);

  return UploadFile;
}(React.Component);

export default UploadFile;